import {TaskManagerMap} from "@/enum";

export const getPipelineTask = (rows) => {
  const dataRow = rows && rows[0] ? rows[0] : null;
  const pipelineTask = dataRow ? dataRow.data : null;
  const pipelineTaskId = dataRow ? dataRow.id : null;
  if (pipelineTask && typeof pipelineTask['6'] === 'string') {
    pipelineTask['6'] = parseInt(pipelineTask['6']);
  }
  return { pipelineTask, pipelineTaskId, dataRow };
}

export const getMappedTask = (task) => {
    if(task) {
      const {data} = task;
      if(!data) {
        return null;
      }
      let finalObject = {};
      let deepCloneTask = JSON.parse(JSON.stringify(data));
      for (let key in deepCloneTask) {
        if (deepCloneTask[key]) {
          finalObject[TaskManagerMap[key]] = deepCloneTask[key];
        }
      }
      return finalObject;
    }
    return null;
}

export const getIsCurrentlyProcessing = (mappedTask) => {
  if (mappedTask) {
    const {prio} = mappedTask;
    if ((prio >= 1 && prio <= 100) || [666, 777, 778].includes(prio)) {
      return true;
    }
  }
  return false;
}